module.exports = __webpack_public_path__ + "img/account_image_cdkey_en@2x.004d1418.png";